import type { EvalCheckVerdict, EvalRunStatus } from './types';

/** Section dividers inside the internal checklist register. */
export const sectionHeaderClasses =
  'flex items-center gap-2 px-4 pt-4 pb-2 text-[11px] font-semibold uppercase tracking-wide text-gray-500';

export const runStatusClasses: Record<EvalRunStatus, string> = {
  PENDING: 'bg-gray-100 text-gray-700',
  RUNNING: 'bg-info-100 text-info-700',
  SUCCEEDED: 'bg-success-100 text-success-700',
  FAILED: 'bg-error-100 text-error-700',
  CANCELLED: 'bg-gray-100 text-gray-500',
};

/**
 * Compact single-line field for the internal grade note: saves on Enter and
 * cancels on Escape, so it carries no buttons and stays near-silent until
 * focused.
 */
export const quietInputClasses =
  'h-7 w-full rounded-md border-none bg-gray-50 px-2.5 text-xs text-gray-900 placeholder:text-gray-400 focus:ring-1 focus:ring-gray-300 focus:outline-none';

/** One segment of the internal grade control; the container supplies the frame. */
export const gradeSegmentClasses = 'px-2.5 py-0.5 text-[11px] font-medium transition-colors';

/** Verdict colour for the checklist register (count strip + group headers). */
export const checkVerdictClasses: Record<EvalCheckVerdict, string> = {
  PASS: 'text-success-700',
  FAIL: 'text-error-700',
  NOT_EVIDENCED: 'text-warning-700',
  NOT_APPLICABLE: 'text-gray-500',
};

/** Leading glyph per verdict — carries the meaning when colour alone can't. */
export const checkVerdictGlyph: Record<EvalCheckVerdict, string> = {
  PASS: '✓',
  FAIL: '✗',
  NOT_EVIDENCED: '?',
  NOT_APPLICABLE: '–',
};
